/* Keep Lumira's custom header and availability labels in sync with Horizon events. */
(() => {
  if (window.lumiraCommerceStateBound) return;
  window.lumiraCommerceStateBound = true;
  let cartRevision = 0;
  let cartRequest;

  const renderCartCount = (count) => {
    if (!Number.isInteger(count) || count < 0) return;
    document.querySelectorAll('[data-ln-cart-count]').forEach((node) => {
      node.textContent = String(count);
    });
  };

  const refreshCart = async () => {
    const revision = ++cartRevision;
    cartRequest?.abort();
    cartRequest = new AbortController();
    const url = document.querySelector('[data-ln-cart-url]')?.dataset.lnCartUrl;
    if (!url) return;
    try {
      const response = await fetch(url, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: cartRequest.signal,
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (revision === cartRevision) renderCartCount(cart.item_count);
    } catch (error) {
      // Keep the last confirmed count on network failure; never guess a total.
    }
  };

  document.addEventListener('cart:update', (event) => {
    if (event.detail?.data?.didError) return;
    const count = event.detail?.resource?.item_count;
    if (Number.isInteger(count) && count >= 0) {
      ++cartRevision;
      cartRequest?.abort();
      renderCartCount(count);
    } else {
      // data.itemCount is the amount added, not the cart total.
      refreshCart();
    }
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refreshCart();
  });

  document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    if (!html?.querySelectorAll) return;
    const incoming = [...html.querySelectorAll('[data-live-product-id]')];
    const variantId = String(event.detail?.resource?.id || '');
    document.querySelectorAll('[data-live-product-id]').forEach((current) => {
      // A product change must not rewrite unrelated recommendation card labels.
      if (!current.closest('.lumira-product-details-column, product-inventory')) return;
      const next = incoming.find((node) =>
        node.dataset.liveProductId === current.dataset.liveProductId &&
        (!variantId || node.dataset.liveVariantId === variantId)
      );
      if (!next) return;
      current.classList.remove('lumira-live-availability--' + current.dataset.liveInventoryStatus);
      current.dataset.liveInventoryStatus = next.dataset.liveInventoryStatus;
      current.dataset.liveInventoryQuantity = next.dataset.liveInventoryQuantity;
      current.dataset.liveVariantId = next.dataset.liveVariantId;
      current.classList.add('lumira-live-availability--' + next.dataset.liveInventoryStatus);
      const message = current.querySelector('[data-live-inventory-message]');
      if (message) message.textContent = next.querySelector('[data-live-inventory-message]')?.textContent || '';
    });
  });
})();
